import { selectAllStrings } from '../language/languageSlice';
import { selectTrendingPoiIds,
        fetchTrendingPois } from './poisSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import PoisSlider from './PoisSlider';

const TrendingPoisSection = () => {
    const strings = useSelector(selectAllStrings);
    const trendingPoiIds = useSelector(selectTrendingPoiIds);
    const trendingPoisStatus = useSelector((state) => state.pois.trendingPois.status);
    const trendingPoisError = useSelector((state) => state.pois.trendingPois.error);
    const dispatch = useDispatch();
    
    useEffect(() => {
        if (trendingPoisStatus === 'idle') {
            dispatch(fetchTrendingPois());
        }
    }, [trendingPoisStatus, dispatch]);
    
    return <div className="trending-pois">
            <h2 className="title">{strings.trending_pois}</h2>
            <Link className="see-all" to={'/trending-pois'}>{strings.see_all}</Link>
            <PoisSlider poiIds={trendingPoiIds} status={trendingPoisStatus} error={trendingPoisError} layout="trending"/>
        </div>
};

export default TrendingPoisSection;